<app-admin *ngIf="user_type == 'admin'"></app-admin>
<app-school *ngIf="user_type == 'school'"></app-school>

<app-region-manager *ngIf="user_type == 'region_manager'"></app-region-manager>